import React from 'react';
import { FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import { Helmet } from 'react-helmet';
import ReactCountryFlag from "react-country-flag";

const ContactUs = () => {
  return (
    <div className="contactus-wrapper">
      <Helmet>
        <title>Contact Us | Pravisht</title>
        <meta name="description" content="Get in touch with Pravisht. We are here to help with your queries, support, and business needs. Visit our office or contact us via phone or email." />
        <meta name="keywords" content="Contact Pravisht, Get in Touch, Email Pravisht, Call Pravisht, Office Address, Contact Form" />
        <meta name="author" content="Pravisht" />
        <meta property="og:title" content="Contact Us | Pravisht" />
        <meta property="og:description" content="We’d love to hear from you! Reach out to Pravisht via our contact form, phone, or email." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.pravisht.com/contact" />
      </Helmet>
      
    <section>
       <div className="breadcrumb">
              {/* <a href="/">Home</a> &gt; <a href="#">Who We Are</a> &gt; <span>About Us</span> */}
               <a href="/" className="mx-1">Home</a> &gt;  <span className="mx-1">Contact Us</span>
           </div>
      <div className="section-header">
        <div className="contact-container">
          <h2>Contact Us</h2>
          <p>
            We’d love to hear from you! Whether you have a question about our solutions, need support, or just want to explore how Pravisht can help your organization—our team is here for you.
          </p>
        </div>
      </div>

     <div className="contact-container">
      <div className="row contact-content">

    <div className="contact-info">

      <h2 style={{ marginBottom: "30px", fontWeight:"600"}}>Address</h2>

      {/* India */}
      <div className="contact-info-content">
        <h4>
  <ReactCountryFlag
    countryCode="IN"
    svg
    style={{
      width: "1.5em",
      height: "1.5em",
      marginRight: "10px",
    }}
  />
  India (Head Office)
</h4>


        <p>
          <FaHome style={{ marginRight: "10px" }} />
          H-91, H Block, Sector-63 Noida, UP-201301, India
        </p>

        <div
          style={{
            display: "flex",
            gap: "40px",
            flexWrap: "wrap",
            marginTop: "10px",
          }}
        >
          <p>
            <FaPhone style={{ marginRight: "10px" }} />
            +1 470 666 8431
          </p>
          <p>
            <FaEnvelope style={{ marginRight: "10px" }} />
            Sales@pravisht.com
          </p>
        </div>
      </div>

      <hr style={{ margin: "30px 0" }} />

      {/* UK */}
      <div className="contact-info-content">
       <h4>
  <ReactCountryFlag
    countryCode="GB"
    svg
    style={{
      width: "1.5em",
      height: "1.5em",
      marginRight: "10px",
    }}
  />
  United Kingdom
</h4>

        <p>
          <FaHome style={{ marginRight: "10px" }} />
          20 Wenlock Road, London, England, N17GU
        </p>

        <div
          style={{
            display: "flex",
            gap: "40px",
            flexWrap: "wrap",
            marginTop: "10px",
          }}
        >
          <p>
            <FaPhone style={{ marginRight: "10px" }} />
            +44 7774 914157
          </p>

          <p>
            <FaEnvelope style={{ marginRight: "10px" }} />
            Sales@pravisht.com
          </p>
        </div>
      </div>

    </div>

    {/* Existing Form */}
    <div className="contact-form">
      <form id="contact-form">
        <h2>Send Message</h2>

        <div className="input-box">
          <input type="text" required />
          <span>Full Name</span>
        </div>

        <div className="input-box">
          <input type="email" required />
          <span>Email</span>
        </div>

        <div className="input-box">
          <textarea required></textarea>
          <span>Type your Message...</span>
        </div>

        <div className="input-box">
          <input type="submit" value="Send" />
        </div>
      </form>
    </div>
  </div>
  </div>
    </section>
    </div>
  );
};

export default ContactUs;

